import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'vibo-ui/Icon';
import Button from 'vibo-ui/Button';
import AuthLayout from 'components/layouts/SignInLayout';

import { ReactComponent as EmptyStateCantResultIcon } from 'resources/img/svg/emptyStateCantResult.svg';

import useCommonStyles from 'resources/styles/common/style';

const ForbiddenPage: FC = () => {
  const commonStylesClasses = useCommonStyles();
  const { t } = useTranslation();

  return (
    <AuthLayout className={commonStylesClasses.errorPage}>
      <Icon icon={EmptyStateCantResultIcon} disableAutoFontSize />
      {t('noPermissionPageText')}
      <Button
        to="/events/upcoming"
        className="homeBtn"
        displayType="bordered"
        shape="round"
        size="lg"
      >
        {t('homePage')}
      </Button>
    </AuthLayout>
  );
};

export default ForbiddenPage;
